var _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightsout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277 280",
    role: "img",
    filter: "url(#grayscale)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "lights out") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C24071",
    d: "M209.761 246.864s-22.447-78.052-5.774-102.556c49.6 11.618 38.059 60.443 38.059 60.443l-32.285 42.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6674",
    d: "M203.986 144.308l.513.13 15.682 45.018 14.71-25.835c.191.27.373.548.555.816l-14.892 26.132 4.524 12.991-.964-.07-9.022-25.895-16.663-4.348c-.052-.313-.096-.635-.139-.949l16.455 4.262-11.071-31.783c.104-.156.2-.313.304-.46l.008-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E56073",
    d: "M210.395 202.116s3.473-40.199 29.523-51.487c27.11 20.713 8.684 54.505 8.684 54.505l-27.5 22.07-10.707-25.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B93870",
    d: "M218.322 173.543l12.157 13.103 8.806-35.738.607-.28c.114.08.208.167.313.245l-4.715 19.13 14.761-7.678.226.418.191.374-15.422 8.034-7.858 31.904 26.267-12.651c-.07.376-.147.741-.234 1.094l-26.311 12.67-5.575 22.653-.469.373-.337-.808 9.55-38.722-12.33-13.26.373-.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE7677",
    d: "M264.527 186.455c-21.335-7.417-43.112 18.261-43.112 18.261l-1.12 14.383a15.81 15.81 0 0 1 4.392 8.643c.209 1.487.47 2.948.809 4.41.06.251.416 1.538.625 2.347.329.948.929 2.713 1.015 2.974.461 1.26.93 2.522 1.399 3.774.247.67.462 1.351.642 2.043 15.908-7.339 42.548-24.713 35.35-56.835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F226D",
    d: "M264.527 186.455c.044.174.079.348.113.523l-32.077 32.382 24.652 2.653c-.207.277-.416.556-.633.825l-24.817-2.669-12.53 12.61.103-1.367 24.393-24.626v-18.878c.295-.133.584-.255.868-.366v18.35l19.434-19.628.468.157.026.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA4771",
    d: "M200.41 279.586h40.255V232.97H200.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E56073",
    d: "M243.565 238.865h-46.022c-1.528 0-2.778-1.532-2.778-3.392 0-1.87 1.25-3.392 2.778-3.392h46.022c1.529 0 2.779 1.522 2.779 3.392 0 1.887-1.25 3.392-2.779 3.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M193.801 268.004s5.14 4.687 16.872 7.617c2.605.652 5.365-.217 5.365 3.965h-14.23l-11.846-2.009v2.01h-6.39s-1.78-10.262 1.954-11.583h8.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B68F",
    d: "M193.08 260.604l.721 7.373a7.344 7.344 0 0 1-7.815.26l-.444-.26-1.345-7.373h8.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M254.49 268.004s5.14 4.687 16.87 7.617c2.606.652 5.367-.217 5.367 3.965h-14.232l-11.844-2.009v2.01h-6.39s-1.781-10.262 1.953-11.583h8.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B68F",
    d: "M251.45 260.604l3.04 7.373a7.344 7.344 0 0 1-7.816.26l-.443-.26-4.836-7.373h10.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45072",
    d: "M45.428 279.586l22.82-78.122-3.327-1.078-23.131 79.2zm106.901 0l-23.133-79.2-3.326 1.078 22.821 78.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A086",
    d: "M34.938 71.477l14.543 5.93-11.234 11.58-8.188-9.421-5.986-1.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B68F",
    d: "M39.178 68.539c.716-1.559 1.195-3.087.957-4.13C35.907 56.786 16.096 53.2 16.096 53.2l-6.443 5.588 1.122 11.755 11.348 6.302a10.51 10.51 0 0 0 9.99-.022 20.626 20.626 0 0 0 7.065-8.284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M18.052 72.414c-1.7-1.467-6.325-3.45-5.018-5.275.953-1.325 3.627-6.192 4.463-7.864 1.99-3.987 3.949-11.862-2.108-14.876-3.03-1.506-7.09.136-8.802 1.605a9.083 9.083 0 0 0-2.971 5.729C2.97 56.876 3.463 64.374 1.82 66.43c-2.728 3.514-2.376 8.562.962 10.133 3.573 1.707 9.813 2.51 14.055 2.448 2.453-.03 4.88-.5 7.169-1.386l-5.954-5.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B68F",
    d: "M16.488 76.672c-.346-1.277.624-2.87 2.173-3.548 1.547-.678 3.066-.2 3.411 1.086.345 1.285-.634 2.87-2.172 3.549-1.54.678-3.066.19-3.412-1.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45072",
    d: "M40.278 86.464L14.975 81.17s15.657 120.564 73.592 130.04c57.935 9.48 92.53-17.286 95.621-18.764-83.16-23.391-143.91-105.983-143.91-105.983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE7677",
    d: "M40.278 79.508l-25.303 1.66s20.293 111.305 78.229 120.757c57.935 9.452 88.988-8.13 90.993-9.478C97.554 168.473 40.278 79.507 40.278 79.507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M107.115 151.647l64.257-1c5.847-.092 10.821 4.254 11.523 10.07l11.097 101.948h-9.63s-22.924-48.81-19.19-74.244c3.733-25.435-89.292-21.305-89.292-21.305l31.235-15.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F226D",
    d: "M37.856 79.635C4.63 123.687 59.981 182.204 59.981 182.204l47.134-30.558c-21.7-28.909-24.955-33.289-55.12-72.015a8.926 8.926 0 0 0-14.139.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B68F",
    d: "M61.798 244.165l1.64-8.273a8.519 8.519 0 0 0-1.019-5.962l-4.109-6.941-.264-1.005-7.138.71a135.984 135.984 0 0 0 1.402 2.177l2.735 4.341s-.48 9.864 2.28 14.201c-2.306 6.97-.557 10.189-.557 10.189l5.03-9.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.853 154.95c2.115 31.312 20.344 71.01 20.344 71.01l6.796-2.093-2.075-80.686s12.235-59.463-14.576-56.014c-20.885 2.688-16.273 43.4-11.228 65.397l.739 2.386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M59.981 182.204s10.316 22.826 53.698 22.826c43.383 0 73.01-15.479 73.01-15.479s12.912 32.879 56 73.114h10.298l-43.573-90.522a22.219 22.219 0 0 0-21.127-12.349l-102.325 5.592-25.98 16.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.114 83.683l9.808-9.955 9.331 2.814L36.99 86.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M173.888 161.385l-50.427 1.763-.122-3.476 48.25-1.687 24.292-54.866 3.177 1.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45072",
    d: "M45.64 268.28l85.186-56.013 1.272 1.94-85.185 56.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45072",
    d: "M62.729 214.236l1.273-1.941 85.185 56.015-1.273 1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M33.432 32.64h7.873v3.058H28.477v-2.096l7.85-11.329h-7.896v-3.07h12.796v2.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6674",
    d: "M53.129 18.353h5.578V21.3H48.309v-2.13l5.431-7.182h-5.193V9.04h10.035v2.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D34F71",
    d: "M70.069 7.078h3.718V9.04h-6.93V7.62l3.62-4.788h-3.463V.87h6.69v1.375z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightsout);
export default __webpack_public_path__ + "static/media/lightsout.77574e65b991d1489cf209bcc4e982f1.svg";
export { ForwardRef as ReactComponent };